import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { ValidationService } from 'src/app/services/validation.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController } from '@ionic/angular';
import { DeepCopyService } from 'src/app/services/deep-copy.service';

@Component({
  selector: 'app-model3d-details',
  templateUrl: './model3d-details.component.html',
  styleUrls: ['./model3d-details.component.scss'],
})
export class Model3dDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public keepAspectRatio:boolean = true;
  
  constructor(
    public authorService: AuthorService,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public assetManagementService: AssetManagementService,
    public fileService: FileService,
    public alertController: AlertController,
    public deepCopyService: DeepCopyService,
  ) { }

  ngOnInit() {
    if (this.currentStepInfo.fileName) 
    this.currentStepInfo.fileName=this.currentStepInfo.fileName
   }    

  getModel3dAsset(): MediaAsset {
    return this.assetInScene.baseAsset as MediaAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var model3dSettingsModal = document.getElementById('add-model3D-object-modal');
    model3dSettingsModal.style.opacity = opacity;
  }

  updateXScale(event, asset){
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    this.authorService.updateScale(asset);
  }
  
  updateYScale(event, asset){
    asset.sceneAssetRelation.yScale = String(event.detail.value);
    this.authorService.updateScale(asset);
  }
  
  updateZScale(event, asset){
    asset.sceneAssetRelation.zScale = String(event.detail.value);
    this.authorService.updateScale(asset);
  }
  
  updateXRot(event, asset){
    asset.sceneAssetRelation.xRot = String(event.detail.value);
    this.authorService.updateRotation(asset.sceneAssetRelation);
  }
  
  updateYRot(event, asset){
    asset.sceneAssetRelation.yRot = String(event.detail.value);
    this.authorService.updateRotation(asset.sceneAssetRelation);
  }
  
  updateZRot(event, asset){
    asset.sceneAssetRelation.zRot = String(event.detail.value);
    this.authorService.updateRotation(asset.sceneAssetRelation);
  }

  async selectFile() {
    let input = document.querySelector('#file-input');
    if(input)
      input.click();
    return
    const alert = await this.alertController.create({
      header: 'Choose Media',
      message: 'Browse for a file on your computer.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Upload from computer',
        cssClass: '',
        handler:  () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }
}
